var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("entry-message-reservation-to-applicant", {
    attrs: {
      id: "message-reservation-canceled",
      "message-reservation": _vm.messageReservation,
      "entry-id": _vm.entryId,
      "reservation-status-label": _vm.cancelReasonText,
      "use-accordion": true,
      "is-withdraw": _vm.isWithdraw,
    },
    on: {
      remove: _vm.remove,
      setMessage: _vm.setMessage,
      downloadFile: _vm.downloadFile,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }